<template>
	<div class="job-valuation-summary-table-header-description tw-flex tw-flex-col">
		<div class="tw-flex tw-flex-1" style="z-index: 1">
			<div class="tw-w-1/2"></div>
			<div class="tw-w-1/2 tw-flex tw-justify-center tw-items-center tw-text-white">Puestos</div>
		</div>
		<div class="tw-flex tw-flex-1" style="z-index: 1">
			<div class="tw-w-1/2 tw-flex tw-justify-center tw-items-center tw-text-white">Valoradores</div>
			<div class="tw-w-1/2"></div>
		</div>
	</div>
</template>

<script>
export default {
	name: 'summary-table-header-description',
};
</script>

<style lang="scss" scoped>
.job-valuation-summary-table-header-description {
	min-width: 200px;
	max-width: 200px;
	min-height: 80px;
	max-height: 80px;
	position: relative;
	overflow: hidden;
	&:before, &:after {
		content: '';
		position: absolute;
	}
	&:before {
		background-color: var(--app-color-primary);
		width: 500px;
		height: 100%;
		transform: rotate(22deg);
		bottom: -15px;
	}
	&:after {
		background-color: var(--app-color-secondary);
		width: 500px;
		height: 100%;
		transform: rotate(22deg);
		top: 65px;
		margin-left: -50%;
	}
}
</style>



// WEBPACK FOOTER //
// src/modules/job-evaluation/components/process/job-valuation/job-valuation-summary-table/summary-table-header-description.vue